import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormConditionRule } from '../Components/Form/Components/FormCondition/FormCondition';
import { Rule } from '../Enums/Rule.enum';

interface useFormConditionProps {
	rules: FormConditionRule[] | undefined;
}

export default function useFormCondition(props: useFormConditionProps) {
	const { rules } = props;
	const { watch } = useFormContext();
	const watchAll = watch();

	const validateRule = (ruleItem: FormConditionRule): boolean => {
		const { formControlKey, rule, value } = ruleItem;

		const formControlValue = watch(formControlKey);

		const realValue =
			formControlValue?.value?.code ??
			formControlValue?.secondaryValue ??
			formControlValue?.value ??
			formControlValue;

		switch (rule) {
			case Rule.FILLED:
				return !!realValue;
			case Rule.EQUAL:
				return realValue === value;
			case Rule.NOT_EQUAL:
				return realValue !== value;
			case Rule.IN:
				return value.indexOf(realValue) !== -1;
			case Rule.STARTS_WITH:
				return [...(Array.isArray(value) ? value : [value])].some(val =>
					(realValue ?? '').startsWith(val),
				);
			case Rule.NOT_STARTS_WITH:
				return [...(Array.isArray(value) ? value : [value])].every(
					val => !(realValue ?? '').startsWith(val),
				);
		}
	};

	const result = useMemo(() => {
		let tempResult = true;

		if (!rules) {
			return tempResult;
		}

		for (const rule of rules) {
			tempResult = validateRule(rule);

			if (!tempResult) {
				break;
			}
		}

		return tempResult;
	}, [rules, watchAll]);
	return {
		result,
	};
}
